export const enum CompanyLogoSubparentType {
  LETTERHEAD_LOGO = "LETTERHEAD_LOGO",
  ICON_LOGO = "ICON_LOGO",
  LIGHT_LETTERHEAD_LOGO = "LIGHT_LETTERHEAD_LOGO",
  CARD_IMAGE = "CARD_IMAGE",
}
